// React Imports
import { ReactElement, useEffect, useState } from "react";

// Third Party Libraries Imports
import { useLocation } from "react-router-dom";

// Local Imports
import BreadcrumbComponent from "../../components/breadcrumb-component/breadcrumb-component";
import TabsComponent from "../../components/tabs-component/tabs-component";
import Pending from "./components/pending/pending";
import Completed from "./components/completed/completed";
import { useDispatch } from "react-redux";
import { CREATE_BREADCRUMB } from "../../store/actions";

const Deposit: React.FC = (): ReactElement => {
  const location = useLocation();
  const dispatch = useDispatch();
  const queryParams = new URLSearchParams(location.search);
  const [activeTab, setActiveTab] = useState<string>(
    queryParams.get("tab") || "1"
  );

  useEffect(() => {
    dispatch({
      type: CREATE_BREADCRUMB,
      payload: {
        breadcrumb: [
          {
            text: "Deposit",
            type: "link",
            link: "/deposit",
          },
        ],
      },
    });
  }, []);

  const items: any = [
    {
      key: "1",
      label: `Pending`,
      children: <Pending />,
    },
    {
      key: "2",
      label: `Completed`,
      children: <Completed />,
    },
  ];

  const onTabChange = (activeKey: string): void => {
    setActiveTab(activeKey);
  };

  return (
    <div className="flex flex-col">
      <div className="flex items-center justify-between flex-wrap">
        <BreadcrumbComponent />
      </div>
      <TabsComponent
        items={items}
        activeTab={activeTab}
        onChange={onTabChange}
      />
    </div>
  );
};

export default Deposit;
